export const formatCurrency = (value: number) => 
  new Intl.NumberFormat('en-US', { 
    style: 'currency', 
    currency: 'USD' 
  }).format(value);

export const formatPercent = (value: number) => 
  `${(value * 100).toFixed(2)}%`;